<template>
  <div>
    <v-btn
      title="Play Golf"
      @click="dialogs.deparmentDialog = true"
      color="blue blue--text"
      block
      outlined
    >
      <v-icon>mdi-swap-horizontal</v-icon>
      {{dataDepartment.departmentName}}
    </v-btn>

    <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="dialogs.deparmentDialog"
      >
        <template>
          <v-card>
            <v-card-text class="">
              <v-row class="">
                <template v-for="(departamento,index) in departamentos">
                  <v-col :key="index" md="6" class="text-center optionDepartment mt-2" @click="selectDepartment(departamento.value)">
                    <img
                      v-if="departamento.value == 'Golf'"
                      style="max-height: 7rem;"
                      class="mt-3"
                      src="../../assets/img/golf-option-course.png"
                    />
                    <img
                    v-else-if="departamento.value == 'TopTracer'"
                    style="max-height: 7rem;"
                    class="mt-3"
                    src="../../assets/img/top-tracer-menu-logo.png"
                    />
                    <img
                    v-else
                    style="max-height: 7rem;"
                    class="mt-3"
                    src="../../assets/img/sports.png"
                    />
                    <p class="text-h5 text-center mt-3 blue--text text--darken-4">
                      {{departamento.text}}
                    </p>
                  </v-col>
                </template>
              </v-row>
              <v-overlay
                  v-if="loading"
              >
                <div class="text-center" >
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="blue darken-4"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </v-overlay>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FabDepartment",
  components: {},
  props: [],
  data() {
    return {
      loading:false,
      departmentName: "Seleccione un departamento para ver la información dando click aqui",
      department: "",
      departamentoSeleccionado: "",
      dialogs:{
        deparmentDialog:false,
      }
    };
  },
  methods: {
    selectDepartment(id) {
      this.loading = true;
      localStorage.setItem("selectedDepartment", id);
      //this.departmentName = this.$pgsHelper.getById(this.departamentos,'id',localStorage.getItem("selectedDepartment")).Nombre
      location.reload();
      //this.$router;
    },
  },
  computed: {
    departamentos() {
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        (dep.text = dep.Nombre), (dep.value = dep.id);
      });
      return departamentos;
    },
    dataDepartment() {
      let department = "";
      let departmentName = "";
      if (localStorage.getItem("selectedDepartment")) {
        department = localStorage.getItem("selectedDepartment");
        departmentName = this.$pgsHelper.getById(
          this.departamentos,
          "id",
          localStorage.getItem("selectedDepartment")
        ).Nombre;
      } else {
        localStorage.setItem(
          "selectedDepartment",
          this.$store.getters.getIdDepartamentos.Golf
        );
        department = this.$store.getters.getIdDepartamentos.Golf;
        departmentName = this.$pgsHelper.getById(
          this.departamentos,
          "id",
          localStorage.getItem("selectedDepartment")
        ).Nombre;
      }
      return { department: department, departmentName: departmentName };
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    if (localStorage.getItem("selectedDepartment")) {
      this.department = localStorage.getItem("selectedDepartment");
      this.departmentName = this.$pgsHelper.getById(
        this.departamentos,
        "id",
        localStorage.getItem("selectedDepartment")
      ).Nombre;
    } else {
      localStorage.setItem(
        "selectedDepartment",
        this.$store.getters.getIdDepartamentos.Golf
      );
      this.department = this.$store.getters.getIdDepartamentos.Golf;
      this.departmentName = this.$pgsHelper.getById(
        this.departamentos,
        "id",
        localStorage.getItem("selectedDepartment")
      ).Nombre;
    }
  },
};
</script>

<style scoped>
  .deparmentLink{
      position: fixed;
      z-index: 10000;
      right: 20px;
      bottom: 20px;
      border-radius: 100px;
      min-width: 60px;
      height: 60px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      transition: all ease-in-out .2s;
      overflow: hidden;
      padding: 0 25px;
      background-color: #01579b!important;
      border-color: #01579b!important;
      color:#fff;
  }
  .optionDepartment{
    cursor: pointer;
  }
  .optionDepartment:hover{
    background: rgb(0 0 0 / 10%);
    border-radius:5px;
  }
</style>